import { useNavigate } from "react-router-dom";
import { Can } from "../../auth/components/Can";
import { Permission } from "../../auth/logic/rbac";
import CaseFilterSection from "./CaseFilterSection";
import CaseListTable from "./CaseListTable";
import PageTitle from "../../pageheader/components/PageTitle";

const CaseManagementPage : React.FC= () => {
    const navigate = useNavigate();

    return (
      <div className="flex-1 bg-gray-50 overflow-auto">
        <div className="flex-1">
          <div className="w-full max-w-none px-6 py-6">
            <PageTitle title="Cases" />
            <div className="mb-4">
              <CaseFilterSection
                onCreateCase={() => navigate("/cases/create")}
              />
            </div>
            <Can
              perform={Permission.LIST_CASES}
              access_denied_message="You don't have the necessary permissions to view the list of cases"
            >
              <CaseListTable />
            </Can>
          </div>
        </div>
      </div>
    );
}

export default CaseManagementPage;